const tagsData = {};
const categoriesData = {}
let selectedCategory;
let tags = {
    selected: [],
    disabled: []
};
let activeItems;

let $filterPane;
let $list;
let $listItems;
let $categoryForms = [];
let $resetButton;

let $categoriesSelect;

// строит массив данных в рантайме по данным из DOM
const buildData = function() {

    if($listItems.length) {
        for(let item of $listItems) {
            const id = item.getAttribute('data-id');
            let tags = item.getAttribute('data-tags');
            let categories = item.getAttribute('data-categories');

            if(tags) {
                tags = tags.trim();
            }

            if(tags && tags.length) {
                tags = tags.split(',');

                //tags = tags.map((idx) => idx);
            } else {
                tags - undefined;
            }

            if(categories) {
                categories = categories.trim();
            }

            if(categories && categories.length) {
                categories = categories.split(',');
            } else {
                categories = [];
            }

            // create array
            if(id && tags) {
                tagsData[id] = tags;
            }

            if(id && categories) {
                categoriesData[id] = categories;
            }
        }
    }
}

// вычисляет айтемы которые подходят исходя из выбранных тегов
const calculateItems = function(categoryChanged = false) {
    activeItems = new Set();

    if (!categoryChanged) {
        for(let i in tagsData) {
            let state = true;

            for(let tagId of tags.selected) {
                if(tagsData[i].indexOf(tagId) === -1) {
                    state = false;
                    break;
                }
            }

            if(state) {
                activeItems.add(i);
            }
        }
    }
}

// вычисляет тэги которые должны быть неактивными в панели фильтров по выбранным айтемам
const calculateDisabledTags = function(categoryChanged = false) {
    const availableTags = new Set();
    tags.disabled = [];

    if (!categoryChanged) {
        for(let item of activeItems) {
            for(let tagId of tagsData[item]) {
                availableTags.add(tagId);
            }
        }

        if(tags.selected.length) {
            const $checkboxes = $filterPane.querySelectorAll('input[type="checkbox"]');
            if($checkboxes.length) {
                for(let $checkbox of $checkboxes) {
                    const id = $checkbox.value;
                    if(id) {
                        if(!availableTags.has(id) && tags.selected.indexOf(id) < 0) {
                            tags.disabled.push(id);
                        }
                    }
                }
            }
        }
    }
}

// перерисовыет панель фильтров и панель выделеных фильтров исходя из состояния
const repaintFilterPane = function(categoryChanged = false) {
    let $checkboxes = $filterPane.querySelectorAll('input[type="checkbox"]');

    if($checkboxes.length) {
        for(let $checkbox of $checkboxes) {
            const id = $checkbox.value;
            if(id) {
                $checkbox.checked = tags.selected.indexOf(id) > -1;

                $checkbox.disabled = tags.disabled.indexOf(id) > -1;
            }
        }
    }

    let $letters = $filterPane.querySelectorAll('.filter-pane__letters__item');

    if($letters.length) {
        for(let $letter of $letters) {
            const id = $letter.getAttribute('data-id');
            if(id) {
                $letter.classList[tags.selected.indexOf(id) > -1 ? 'add' : 'remove']('_active');
                $letter.classList[tags.disabled.indexOf(id) > -1 ? 'add' : 'remove']('_disabled');
            }
        }
        console.info('$letter', tags.disabled);
    }
}

// перерисовыет айтемы исходя из текущго состояния
const repaintItems = function(categoryChanged = false) {
    if($listItems.length) {
        const selectedTagsCount = tags.selected.length;

        if ($resetButton) {
            $resetButton[0].classList[tags.selected.length || selectedCategory ? 'add' : 'remove']('active');
        }

        for(let $item of $listItems) {
            const itemId = $item.getAttribute('data-id');

            if(itemId) {
                if (selectedCategory) {
                    $item.classList[categoriesData[itemId].indexOf(selectedCategory) >= 0 ? 'remove' : 'add']('d-n');
                } else {
                    if(!selectedTagsCount) {
                        $item.classList.remove('d-n');
                    }
                    else {
                        $item.classList[activeItems.has(itemId) ? 'remove' : 'add']('d-n');
                    }
                }
            }
        }
    }
}

// устанавливает новый урл-хэш исходя из текущих данных
const updateHash = function(isUpdateHash = true, categoryChanged = false) {
    if(isUpdateHash) {
        let hash;
        if (categoryChanged) {
            hash = selectedCategory ? 'cat' + selectedCategory : '';
        } else {
            hash = tags.selected.join(',');
        }

        if(history.pushState) {
            history.pushState(null, null, `#${hash}`);
        }
        else {
            window.location.hash = hash;
        }
    }
}

// парсит хэш строку браузера и устанавливает исходные значения исходя из нее
// вызывает перерисовку, без обновления истории браузера
const updateByHash = function(isOnLoad = false) {
    if(!isOnLoad || window.location.hash.length > 1) {
        if (window.location.hash.substring(1, 4) === 'cat') {
            selectedCategory = window.location.hash.substring(4);
            render(false, true);
        } else {
            const query = window.location.hash.substring(1).split(',');
            const tempSet = new Set();

            query.forEach(item => {
                item = decodeURIComponent(item.trim());
                if(item.length) {
                    tempSet.add(item);
                }
            });

            if(tempSet.size) {
                tags.selected = Array.from(tempSet);
                // ложь передает что бы история браузера не обновлялась
                render(false, false);
            }
        }
    }
}

const reset = function () {
    selectedCategory = undefined;
    $categoryForms.each(function(index, form) { form.reset(); });
    render(true, true);
}

// вызывает все методы которые нужны для перерисовки состояния по текущим данных
const render = function(isUpdateHash = true, categoryChanged = false, targetForm = undefined) {
    if (categoryChanged) {
        tags.selected = [];

        $categoryForms.each(function(index, form) {
            if (form !== targetForm) {
                form.reset();
            }
        });
    } else {
        selectedCategory = undefined;
        $categoryForms.each(function(index, form) { form.reset(); });
    }

    calculateItems(categoryChanged);
    calculateDisabledTags(categoryChanged);
    repaintFilterPane(categoryChanged);
    repaintItems(categoryChanged);
    updateHash(isUpdateHash, categoryChanged);
}

export default (function($) { return function() {
    $list = document.querySelector('.js-vendor-list');

    $categoryForms = $('.js-vendor-category-form');
    if ($categoryForms === null) {
        $categoryForms = [];
    }

    if($list) {
        $listItems = $list.querySelectorAll('li.js-vendor-list-item');
    }

    $filterPane = document.querySelector('.js-filter-pane');

    if(!$list || !$filterPane) {
        return;
    }

    buildData($list);

    let changeEvent = $('.js-vendor-category').attr('data-change-event');
    if (changeEvent) {
        $(document).on(changeEvent, function (e, value, target) {
            selectedCategory = value;
            render(true, true, $(target).closest('form')[0])
        });
    }

    $resetButton = $('.js-vendor-filters-reset');
    if ($resetButton) {
        $resetButton.on('click', function () {
            reset();
        });
    }

    $filterPane.addEventListener('change', function(e) {
        e.preventDefault();

        if(e.target.tagName === 'INPUT') {
            const id = e.target.value;

            if(e.target.checked) {
                tags.selected.push(id);
            }
            else {
                tags.selected = tags.selected.filter(i => i !== id);
            }

            render(true);
        }
    });

    $filterPane.addEventListener('click', function(e) {
        if(e.target.classList.contains('filter-pane__letters__item')) {
            const isActive = e.target.classList.contains('_active');
            const id = e.target.getAttribute('data-id');

            tags.selected = tags.selected.filter(i => !isNaN(i));

            if(!isActive) {
                tags.selected.push(id);
            }

           render(true);
        }
    });

    updateByHash();

    window.addEventListener('popstate', function() {
        setTimeout(function() {
            updateByHash();
        }, 100);
    })
}; })(require('jquery'));
